var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.811 6.15524C19.1323 5.78115 19.0895 5.21745 18.7153 4.89618C18.3413 4.57491 17.7776 4.61774 17.4563 4.99183C14.8316 8.04804 14.7943 8.33349 12 11.1926C9.20565 8.33349 9.16829 8.04804 6.54365 4.99183C6.22237 4.61774 5.65868 4.57491 5.28458 4.89618C4.91049 5.21745 4.86767 5.78115 5.18893 6.15524C7.84559 9.24874 7.91634 9.5701 10.7455 12.4638C8.01964 15.1995 7.87465 15.1832 4.96737 17.7582C4.59823 18.0852 4.56404 18.6495 4.891 19.0187C5.21795 19.3878 5.78224 19.422 6.15138 19.0951C9.08275 16.4985 9.25125 16.4929 12 13.7347C14.7487 16.4929 14.9172 16.4985 17.8486 19.0951C18.2177 19.422 18.782 19.3878 19.1089 19.0187C19.4359 18.6495 19.4017 18.0852 19.0326 17.7582C16.1253 15.1832 15.9803 15.1995 13.2545 12.4638C16.0836 9.5701 16.1543 9.24874 18.811 6.15524Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/Close-X.4522268d.svg";
export { ForwardRef as ReactComponent };